// navigationService.js
let navigate: any;

export const setNavigate = (navigateFunction: any) => {
    navigate = navigateFunction;
};

export const navigateTo = (path: any, options?: any) => {
    if (navigate) {
        const { relative } = options ?? {}
        if (relative) {
            const relativePath = window.location.pathname.replace(process.env.PUBLIC_URL, '')
            path = `${relativePath}/${path}`
        }
        navigate(path);
    } else {
        console.error('Navigate function is not set');
    }
};